import React from "react";
import Login from "../../components/login";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { otpRequest, otpReset } from "../../store/actions/otpAction";
import { loginRequest } from "../../store/actions/loginAction";
import { useNavigate } from "react-router";
import { omit } from "lodash";
import Loader from "../../components/Loader/Loader";
import OTPInput from "react-otp-input";

export default function LoginContainer(){

    const [fields, setFields] = useState({
        phone:'',
        otp:''
    });
    const [showInvalid, setShowInvalid] = useState(false);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loginObj = useSelector(state => state.loginReducer);
    const { loading, loginResult } = loginObj;
    const otpObj = useSelector(state => state.otpReducer);
    const { otpReq, otpResult } = otpObj;
    let errorReturn = {};
    let errorObj = errors;
    useEffect(() => {
        if(loginResult?.status){
            navigate('/auctionListPage');
        }
    },[loginResult?.data])

    const [timer, setTimer] = useState(100); // Timer in seconds

    useEffect(() => {
        dispatch(otpReset())
    },[])

            

    // useEffect(() => {
    //   if (otpResult?.status && timer > 0) {
    //     const interval = setInterval(() => {
    //       setTimer(prevTimer => prevTimer - 1);
    //     }, 1000);
        
    //     return () => clearInterval(interval);
    //   }
    // }, [otpResult?.status]);

    const validate = (name, value) => {
        if(value === "" && name==="phone"){
            errorObj =  {...errorObj, [name]: "Please enter mobile number."};
        }else if(value !== "" && name==="phone" && (isNaN(value) || !((/^[0-9]{10}/).test(value)) || value.length > 10) ){
            ///^[6-9][0-9]{10}/
            errorObj =  {...errorObj, [name]: "Please enter valid mobile number."};
        }else if(value === "" && otpResult?.status && name==="otp"){
            errorObj =  {...errorObj, [name]: "Please enter otp."};
        }else if(value !== "" && otpResult?.status && name==="otp" && (isNaN(value) || value.length !== 4)){
            errorObj =  {...errorObj, [name]: "Please enter valid otp."};
        }else if(errors?.hasOwnProperty(name)){
            let newObj = omit(errors, name);
            errorObj = newObj;
        }

        return errorObj;
    }

    const submitOtpRequest = (e) => {
        e.preventDefault();

        let defaultFieldJsonKey = Object.keys(fields); 
        for(let i = 0; i < defaultFieldJsonKey.length; i++){
          if(defaultFieldJsonKey){
              errorReturn = validate(defaultFieldJsonKey[i], fields[defaultFieldJsonKey[i]]);
          }
        }    
        if(Object.keys(errorReturn).length === 0){
            if(!otpResult?.status){
                dispatch(otpRequest({otpReq:fields.phone}))
            }else if(otpResult?.status){
                dispatch(loginRequest({loginReq:fields}))
                setShowInvalid(true);
            }
        }else{
            setErrors(errorReturn);
        }
    }

    const handleChange = (e,fieldName) => {
        if(fieldName){
            errorReturn = validate(fieldName,e);
            setShowInvalid(false);
            setErrors(errorReturn);
            setFields(prev => ({
                ...prev,
                [fieldName]: e
           }))
        }else{
            const { name, value } = e.target;
            errorReturn = validate(name,value);
            dispatch(otpReset())
            setErrors(errorReturn);
            setFields(prev => ({
                ...prev,
                [name]: value
           }))
        }

    }

    return (
        <Login>
            <Login.ContainerLeft>
                <Login.Form>
                    <Login.Logo src="../assets/title/Tractor world Logo.svg" alt="Tractor world Logo" />
                    <Login.WelcomeText>Welcome Back</Login.WelcomeText>
                    <Login.SmallText>Thank you for joining Tractor World</Login.SmallText>
                    {!otpResult?.status && <div style={{marginBottom:'39px'}}>
                    <Login.InputIconContainer style={{marginBottom:'0px'}}>
                        <img src="../assets/icons/cal.svg" alt="call" />
                        <Login.Input type="number" name="phone" placeholder="Mobile Number" id="phone" value={fields.phone} onChange={(e) => handleChange(e)} />
                    </Login.InputIconContainer>                
                    {errors.phone && <span style={{color: "red"}}>{errors.phone}</span>}
                    {(fields.phone.length === 10 && otpReq && otpResult?.hasOwnProperty('status') && !otpResult?.status) && <span style={{color: "red"}}>You are not registered user.</span>}
                    </div>}
                    {otpResult?.status &&
                    <>
                        <Login.Label>Enter OTP</Login.Label>
                        <Login.OTPContainer>
                        <OTPInput
                            name="otp"
                            id="otp"
                            value={fields["otp"]}
                            onChange={(e) => handleChange(e,"otp")}
                            numInputs={4}
                            isInputNum={true}
                            isInputSecure={true}
                            renderSeparator={false}
                            containerStyle="containerStyle"
                            inputStyle={{width:'46px',height:'46px',borderRadius: '4px',border: '1px solid #CCC',background: '#FFF'}}
                            renderInput={(props) => <input {...props} />}
                        />
                        {errors.otp && <span style={{color: "red"}}>{errors.otp}</span>}
                        {(fields.otp.length === 4 && !loginObj.loading && showInvalid && loginResult?.hasOwnProperty('status') && !loginResult?.status) && <span style={{color: "red"}}>Invalid otp.</span>}
                        </Login.OTPContainer>
                    </>
                    }
                    {(loading || otpObj.loading) ? <Loader /> : <Login.Button onClick={(e) => submitOtpRequest(e)} >{otpResult?.status ? `LOG IN` : 'GET OTP'}</Login.Button>}
                </Login.Form>
            </Login.ContainerLeft>
            <Login.ContainerRight />
        </Login>
    )
}